import React from 'react'
import StripeGiftPayment from './StripeGiftPayment'

const propTypes = {}

function PaymentStep() {
  return <StripeGiftPayment />
}

PaymentStep.propTypes = propTypes

export default PaymentStep

